import { SetStateAction } from "react";
import {
  BookingServiceEditedData,
  BookingServiceRoomLayoutData,
  ServiceOrderDto
} from "../Domain/BookingServicePrompt.types";
import { BookingInputs } from "../../../../../Domain/Types/BookingInputs.type";
import { isServiceItemOrderable } from "../functions/filterByServiceTime.function";

/**
 * mapping room layout table data filter by service time and include/exclude based on the orderable boolean
 */
export function mapRoomLayoutTableData(
  bookingInputs: BookingInputs,
  entries: BookingServiceRoomLayoutData[],
  maxSetupTime: number,
  isServiceAdminBypass = false
) {
  return entries
    .filter(entry => {
      const entrySetUpTime = entry.setUpTime ?? 15;
      const entryBookingLeadTime = entry.bookingLeadTime ?? 1;

      return isServiceItemOrderable({
        bookingFrom: bookingInputs.bookingFrom,
        bookingStart: bookingInputs.bookingStart,
        setUpTime: entrySetUpTime,
        bookingLeadTime: entryBookingLeadTime,
        maxSetupTime,
        isServiceAdminBypass
      });
    })
    .map(layout => ({
      id: layout.id,
      name: layout.name,
      description: layout.description,
      layout: layout.arrangement,
      picturePath:
        layout.picturePaths && layout.picturePaths.length > 0 ? layout.picturePaths.at(-1) : null,
      selectingIsMandatory: layout.selectingIsMandatory ?? false,
      setUpTime: layout.setUpTime,
      bookingLeadTime: layout.bookingLeadTime,
      orderable: true
    }));
}

export function initiateRoomLayoutData({
  bookingInputs,
  maxSetupTime,
  assignedRoomLayoutItems,
  conferenceService,
  isServiceAdminBypass = false,
  setEditedService,
  setOrderedService
}: {
  bookingInputs: BookingInputs;
  maxSetupTime: number;
  assignedRoomLayoutItems: any[];
  conferenceService: ServiceOrderDto | undefined;
  isServiceAdminBypass?: boolean;
  setEditedService: (value: SetStateAction<BookingServiceEditedData>) => void;
  setOrderedService: (value: SetStateAction<ServiceOrderDto>) => void;
}) {
  setEditedService(prev => ({
    ...prev,
    roomLayoutData: mapRoomLayoutTableData(
      bookingInputs,
      assignedRoomLayoutItems,
      maxSetupTime,
      isServiceAdminBypass
    )
  }));

  if (conferenceService?.roomLayout && conferenceService?.roomLayout.length > 0) {
    setOrderedService(prev => ({
      ...prev,
      roomLayout: conferenceService?.roomLayout
    }));
  }
}
